import { Grid } from '@chakra-ui/react';
import {
  REVIEW_CYCLE_STEPS_V1,
  useIsAllEmployeesSelected,
  useReviewCreationData,
  useSelectedEmployeeCount,
} from 'reducers/reviewCreationSlice';

import { Peers } from 'assets/assetsV1/iconComponents';

import {
  ExpandablePaper,
  ExpandablePaperBody,
  ExpandablePaperHeader,
} from 'uiToolkitV1/ExpandablePaper/ExpandablePaper';

import { useGetReviewees } from '../../Hooks/dataHooks/revieweesDataHooks';
import { Detail, RenderDetails } from './RenderDetails';

export const Reviewees = () => {
  const { reviewCycleId } = useReviewCreationData();
  const { data: { cohorts, hasCustomSettings } = {}, isLoading } = useGetReviewees({
    reviewCycleId,
    step: REVIEW_CYCLE_STEPS_V1.SUMMARY,
  });
  const selectedEmployeeCount = useSelectedEmployeeCount();
  const isAllEmployeesSelected = useIsAllEmployeesSelected();

  const details: Detail[] = [
    {
      key: 'Review for:',
      value: isAllEmployeesSelected ? 'All Employees' : cohorts?.map((c) => c.name).join(', '),
    },
    {
      key: 'Number of employees:',
      value: selectedEmployeeCount,
    },
    {
      key: 'Customize settings for different views:',
      value: hasCustomSettings ? 'Yes, Customize' : 'No',
    },
  ];

  return (
    <ExpandablePaper showLoader={isLoading}>
      <ExpandablePaperHeader title="Reviewees" leftIconComponent={<Peers boxSize="24px" color="icon.g2" />} />
      <ExpandablePaperBody>
        <Grid templateColumns="1fr 2fr" rowGap={8} columnGap={8} p="16px 8px 12px">
          <RenderDetails details={details} />
        </Grid>
      </ExpandablePaperBody>
    </ExpandablePaper>
  );
};
